module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 5-cbb854d33b21036dd34d8fb5125871fc.jpg";